import { useState } from "react";
import {
  IInfinitePageParams,
  IInfinitePageStatisticsResponse,
} from "services/types";

export const getDefaultInfinitePageParam = (page = 0, itemCount = 15) => ({
  page,
  itemCount,
});

export const useInfiniteHandlerWithStatistics = <T, S>(
  params?: IInfinitePageParams
) => {
  const [totalPageCount, setTotalPageCount] = useState<number>(0);
  const [statistics, setStatistics] = useState<S | undefined>();

  const getNextPageParam = (lastPage: T[], allPages: T[][]) => {
    const nextPage = allPages.length;
    const maxPage = totalPageCount - 1;

    return nextPage <= maxPage ? nextPage : undefined;
  };

  const infiniteHandlerWithStatistics = (
    data: IInfinitePageStatisticsResponse<T, S>
  ) => {
    setTotalPageCount(data.totalPageCount);
    setStatistics(data.statistics);

    return data.items;
  };

  const defaultPageParams = {
    page: params?.page ?? 0,
    itemCount: params?.itemCount ?? 15,
  };

  return {
    getNextPageParam,
    setTotalPageCount,
    infiniteHandlerWithStatistics,
    defaultPageParams,
    statistics,
  };
};
